import React, { Fragment } from 'react'
import {
  Section,
  Image,
  InputTextarea,
  AttachedFile,
} from '../../../../components'
import { ICONS } from '../../../../themes'
import ApprovalStep from './ApprovalStep'

const ApprovalWorkflow = ({ workflow }) => {
  const { levels = [] } = workflow || {}

  const requesterLevel = levels.find(l => l.level === 0)
  const approvalLevels = levels.filter(l => l.level !== 0)

  return (
    <Section className="form-wrapper">
      <Section className="form-group-title">Approval Workflow</Section>
      <Section className="approval-workflow">
        <Section className="approval-step">
          {requesterLevel &&
            requesterLevel.approvers.map((u, i) => (
              <Fragment key={`req-${i}`}>
                <ApprovalStep name={u.name} status={u.status} />
                {levels.length > 1 && (
                  <Image src={ICONS['chevron-right-solid.svg']} />
                )}
              </Fragment>
            ))}

          {approvalLevels.map((level, idx) => {
            const isLast = idx === approvalLevels.length - 1

            if (level.condition === 'serial') {
              return level.approvers.map((u, i) => (
                <Fragment key={`serial-${idx}-${i}`}>
                  <ApprovalStep name={u.name} status={u.status} />
                  {!isLast || i < level.approvers.length - 1 ? (
                    <Image src={ICONS['chevron-right-solid.svg']} />
                  ) : null}
                </Fragment>
              ))
            }

            if (
              level.condition === 'parallel_or' ||
              level.condition === 'parallel_and'
            ) {
              return (
                <Fragment key={`parallel-${idx}`}>
                  <div className="approval-parallel">
                    {level.approvers.map((u, i) => (
                      <ApprovalStep key={i} name={u.name} status={u.status} />
                    ))}
                  </div>
                  {!isLast && <Image src={ICONS['chevron-right-solid.svg']} />}
                </Fragment>
              )
            }
            return null
          })}
        </Section>
      </Section>

      <Section className="form-row">
        <Section className="form-col col-6">
          <Section className="form-group">
            <label>
              Internal Note <br />
              (Optional)
            </label>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper">
                <InputTextarea
                  className="input-internal-note"
                  value={''}
                  onChange={() => {}}
                  readOnly={false}
                />
              </Section>
              <Section className="message"></Section>
            </Section>
          </Section>
        </Section>
      </Section>

      <Section className="form-row">
        <Section className="form-col col-6">
          <Section className="form-group">
            <label className="tooltip-upload internal-attachment">
              Internal Attachment <br />
              (Optional)
            </label>
            <Section className="form-group-attached-file">
              <AttachedFile
                id="upload-event-internal"
                classNameInput={'form-group-attached-file-wrapper'}
                onSelect={() => {}}
                isHideIput={true}
                isDisableInput={false}
                fileList={[]}
                onDownload={() => {}}
                isIcon={true}
                hasRemove={false}
                onClickRemove={() => {}}
                loadingDownload={false}
              />
            </Section>
          </Section>
        </Section>
      </Section>
    </Section>
  )
}

export default ApprovalWorkflow
